import React, { useEffect, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { TableUrlPagination } from '../../../../ui'
import { granConsumoDataPreparation } from '../../logics'
import { GRANCONSUMO_TABLE_COLUMNS } from '../../constants'
import { useRowSelector } from '../../../loader/hooks'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const GCTable = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const paymentsLoader = useSelector((state) => state.loader.gestoresGc)
  const combos = useSelector((state) => state.combos)

  const data = paymentsLoader?.data?.registros || []
  const totalEntries = paymentsLoader?.data?.total_registros
  const search = paymentsLoader?.config?.params
  const loading = paymentsLoader?.loading

  const { selection, addSelection } = useRowSelector({
    identifier: 'gestoresGc',
    selectFilter: (state) => state?.data?.registros,
    idField: 'id',
  })

  useEffect(() => {
    if (selection.length) {
      addSelection([])
    }
  }, [])

  const handleSelectRows = useCallback(
    (rows) => {
      addSelection(rows)
    },
    [addSelection]
  )

  const formattedColumns = useMemo(() => {
    return GRANCONSUMO_TABLE_COLUMNS.map((column) => {
      const baseColumn = {
        accessorKey: column.field,
        header: formatMessage({ id: `pages.gran_consumo.table.columns.${column.field}.title` }),
        size: column.width,
        minSize: column.width,
        maxSize: column.width,
      }

      if (column.field === 'actions') {
        return {
          ...baseColumn,
          header: formatMessage({ id: 'global.actions' }),
          Cell: (props) => <span>Acciones</span>, // Replace with actual actions component
          muiTableBodyCellProps: { align: 'center' },
        }
      }

      if (column.comboId && combos[column.comboId]?.data) {
        const lookup = getLookup(combos[column.comboId].data)
        return {
          ...baseColumn,
          Cell: ({ cell }) => {
            const value = cell.getValue()
            return <span>{lookup[value] ?? value ?? '--'}</span>
          },
        }
      }

      return {
        ...baseColumn,
        Cell: ({ cell }) => <span>{cell.getValue() ?? '--'}</span>,
      }
    })
  }, [combos, formatMessage])

  const processedData = useMemo(() => granConsumoDataPreparation(data, { intl }), [data, intl])

  const finalTableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: true,
      draggable: false,
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={finalTableOptions}
      totalEntries={totalEntries}
      search={search}
      data={processedData}
      isLoading={loading}
      onSelectionChange={handleSelectRows}
    />
  )
}
